module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./~/sass-loader!./~/extract-text-webpack-plugin/loader.js?{"omit":1,"remove":true}!./~/style-loader!./~/css-loader!./~/sass-loader?sourceMap!./src/app/theme/initial.scss
// module id = 488
// module chunks = 16